export default "__VITE_ASSET__DldgPwUp__"